module.exports = __webpack_public_path__ + "ed6ecdaf353dfdff4b7e920d0c531b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-31.jpg
// module id = 1173
// module chunks = 0